/** Whether a link stays inside the app: a root-relative path that opens in
 * this window. Such a link navigates through the router, so the shell around
 * the page stays mounted. */
export function isInAppPath(href: string, target?: string): boolean {
  return href.startsWith("/") && !href.startsWith("//") && target !== "_blank";
}
